export const PHONE_VALIDATION_RGEXP = /^\(?([0-9]{3})\)?[-]([0-9]{3})[-]([0-9]{4})$/;
export const PHONE_VALIDATION_MESSAGE = 'The Phone Number must be like XXX-XXX-XXXX.';
